import React, {Component} from 'react'
import PropsTypes from "prop-types";
import {_createNewAccount} from "../../../../services/apis/AccountServices";

class CreateNewAccount extends Component {
    state = {
        email: '',
        password: '',
        recoverEmail: '',
        // recoverPassword: '',
        recoverPhone: '',
        note: '',
        cookies: '',
    }

    _handleSubmit = (e) => {
        e.preventDefault();

        const {email, password, recoverEmail, recoverPhone, note} = this.state;

        _createNewAccount({email, password, recoverEmail, recoverPhone, note})
            .then(result => {
                if (result.success) {
                    this.setState({
                        email: '',
                        password: '',
                        recoverPhone: '',
                        recoverEmail: '',
                        note: ''
                    })

                    this.props.onRefreshPage()
                }
            })
    }

    _handleChangeTextForm = field => e => {
        const {value} = e.target;

        this.setState({[field]: value})
    }

    render() {
        const {email, password, recoverEmail, recoverPhone, note} = this.state;

        return (
            <div className="CreateNewEvent col-md-4 col-12">
                <form onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <input className='form-control' value={email} placeholder='Email'
                               onChange={this._handleChangeTextForm('email')}
                        />
                    </div>
                    <div className="form-group">
                        <input className='form-control' value={password} placeholder='Password'
                               onChange={this._handleChangeTextForm('password')}
                        />
                    </div>
                    <div className="form-group">
                        <input className='form-control' value={recoverPhone} placeholder='Phone'
                               onChange={this._handleChangeTextForm('recoverPhone')}
                        />
                    </div>
                    <div className="form-group">
                        <input className='form-control' value={recoverEmail} placeholder='Recover email'
                               onChange={this._handleChangeTextForm('recoverEmail')}
                        />
                    </div>
                    <div className="form-group">
                        <input className='form-control' value={note} placeholder='Note'
                               onChange={this._handleChangeTextForm('note')}
                        />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-success" type='submit'>Create</button>
                    </div>
                </form>
            </div>
        )
    }
}

CreateNewAccount.propsTypes = {
    onRefreshPage: PropsTypes.func.isRequired
}

export default CreateNewAccount


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/accounts/CreateNewAccount.js